<template>
  <fs1-dialog id="edit_finding" :title="`Editar hallazgo ${finding_code||'-'}`"  max_width="600">
    <template v-slot:body>
      <fs1 tag="p" class="text_align_left" v-if="is_edit_steps">
        Hallazgo {{finding_code}} se ha modificado exitosamente. La siguiente tabla muestra los pasos del hallazgo  {{finding_code}} que se encuentran disponibles para editar. Puede continuar editando este hallazgo o bien, volver al listado de hallazgos identificados en plataforma.
      </fs1>
      <fs1 tag="p" class="text_align_left" v-else>
      La siguiente tabla muestra los pasos del hallazgo {{finding_code}} que se encuentran disponibles para editar
      </fs1>
      <v-data-table
        :headers="[{text:'N°',value:'step'},{text:'Paso',value:'name'},{sortable:false,text:'Acción',value:'accion',class:'width50px'},,{sortable:false,text:'',value:'check',class:'width50px'}]"
        :items="steps"
        class="tablaLT1 issues"
        :class="dark_t?'dark':''">
        <template v-slot:item.accion="{item}">
          <div style="text-align:center"><v-icon @click="edit_step(item)">edit</v-icon></div>
        </template>
        <template v-slot:item.step="{value}">
          <div style="text-align:center">{{value}}</div>
        </template>
        <template v-slot:item.check="{value}">
          <div style="text-align:center" v-if="value">
            <v-icon>check</v-icon>
          </div>
        </template>
      </v-data-table>
    </template>
    <template v-if="aaa" v-slot:footer="{close}">
      <v-btn color="primary" @click="()=>close_aaa(close)">Listado de Hallazgos</v-btn>
      <v-btn color="secondary" @click="close">Continuar Editando</v-btn>
    </template>
  </fs1-dialog>
  
</template>
<script>
export default {
  props:['steps','finding_code','id','aaa','simulation','ext_chn_stp'],
  computed:{
    active_router_name(){ return this.$router.currentRoute.name },
    is_edit_steps(){return this.active_router_name.includes('edit_steps')}
  },
  watch:{
    ext_chn_stp(step){
const item = this.steps[step-1];
if (this.steps.length >= step) this.edit_step(Object.assign({step},{...item}));
    }
  },
  methods:{
		edit_step(item){
			this.close_dialog();

      this.$router.push({ 
        name: 'findings/edit_steps', 
        params: { k: item.step, id:this.id },
        path: '/findings/edit_steps', 
        query: {key: 'not-sensitive'} 
      });
		},
    close_aaa(m){
      m();
      this.$router.push({ name:'findings'})
    }
  }
};
</script>
